import type { ComponentType } from "react";
import { RelayEnvironmentProvider } from "react-relay";

import { createClientUserServiceClientEnvironment } from "~/lib/relay/environment.client";

export function withUserServiceEnvironment<Props extends object>(Component: ComponentType<Props>) {
  const WrappedComponent = (props: Props) => (
    <RelayEnvironmentProvider environment={createClientUserServiceClientEnvironment()}>
      <Component {...props} />
    </RelayEnvironmentProvider>
  );
  return WrappedComponent;
}
